import { Domain } from "./domain";
import { EventBase } from "./eventBase";
const LicenseEvent = {
    LICENSE_PAIRED: "License Paired",
    PURCHASE_INITIATED: "Purchase Initiated",
    TRIAL_GRANTED: "Trial Granted",
};
class LicenseEventBase extends EventBase {
    constructor(payload) {
        super({
            context: payload,
            contentId: payload.licenseId,
        });
    }
    get domain() {
        return Domain.LICENSE;
    }
}
export class LicensePaired extends LicenseEventBase {
    constructor(payload, context) {
        super({ ...payload, ...context });
    }
    get eventName() {
        return LicenseEvent.LICENSE_PAIRED;
    }
}
export class PurchaseInitiated extends LicenseEventBase {
    constructor(payload) {
        super(payload);
    }
    get eventName() {
        return LicenseEvent.PURCHASE_INITIATED;
    }
}
export class TrialGranted extends LicenseEventBase {
    constructor(payload, context) {
        super({ ...payload, ...context });
    }
    get eventName() {
        return LicenseEvent.TRIAL_GRANTED;
    }
}
//# sourceMappingURL=licenseEvents.js.map